import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"
import {
  getPreOrders,
  getPreOrder,
  createPreOrder,
  editPreOrder,
  deletePreOrder,
  cancelPreOrder,
  createMoneyReceiptFromPreOrder,
  getTrashedPreOrders,
  restorePreOrder,
  forceDeletePreOrder,
} from "api/preOrderApi"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const PRE_ORDER_QUERY_KEY = "pre-orders"

// -------------------- FETCH PAGINATED --------------------
export const usePreOrders = (params = {}, enabled = true) => {
  return usePaginatedResource(
    PRE_ORDER_QUERY_KEY,
    getPreOrders,
    params,
    enabled
  )
}

// -------------------- FETCH SINGLE ITEM --------------------
export const usePreOrder = (id, enabled = true) => {
  return useResourceItem(PRE_ORDER_QUERY_KEY, getPreOrder, id, enabled)
}

// -------------------- CREATE --------------------
export const useCreatePreOrder = () => {
  return useCreateResource(createPreOrder, PRE_ORDER_QUERY_KEY)
}

// -------------------- EDIT --------------------
export const useEditPreOrder = () => {
  return useEditResource(editPreOrder, PRE_ORDER_QUERY_KEY)
}

// -------------------- DELETE --------------------
export const useDeletePreOrder = () => {
  return useDeleteResource(deletePreOrder, PRE_ORDER_QUERY_KEY)
}

// -------------------- CANCEL --------------------
export const useCancelPreOrder = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: cancelPreOrder,
    onSuccess: () => {
      queryClient.invalidateQueries([PRE_ORDER_QUERY_KEY])
    },
  })
}

// -------------------- GENERATE MONEY RECEIPT --------------------
export const useCreateMoneyReceiptFromPreOrder = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createMoneyReceiptFromPreOrder,
    onSuccess: () => {
      queryClient.invalidateQueries([PRE_ORDER_QUERY_KEY])
      queryClient.invalidateQueries(["money-receipts"])
    },
  })
}

// -------------------- TRASHED --------------------
export const useTrashedPreOrders = (params = {}) => {
  return usePaginatedResource(
    PRE_ORDER_QUERY_KEY,
    getTrashedPreOrders,
    params,
    true
  )
}

// -------------------- RESTORE --------------------
export const useRestorePreOrder = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: restorePreOrder,
    onSuccess: () => {
      queryClient.invalidateQueries([PRE_ORDER_QUERY_KEY])
    },
  })
}

// -------------------- FORCE DELETE --------------------
export const useForceDeletePreOrder = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: forceDeletePreOrder,
    onSuccess: () => {
      queryClient.invalidateQueries([PRE_ORDER_QUERY_KEY])
    },
  })
}
